import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import flash from './modules/flash';
import main from './modules/main';
import meetingAgendas from './modules/meetingAgendas';
import allergyKpis from './modules/allergyKpis';
import audiologyKpis from './modules/audiologyKpis';
import banners from './modules/banners';
import connections from './modules/connections';
import digitalPromo from './modules/digitalPromo';
import fuelFunds from './modules/fuelFunds';
import fuelUtilization from './modules/fuelUtilization';
import professionalDevelopment from './modules/professionalDevelopment';
import library from './modules/library';
import pricingGuides from './modules/pricingGuides';
import batteryStore from './modules/batteryStore';
import payInvoice from './modules/payInvoice';
import purchaseActivity from './modules/purchaseActivity';
import vendorPartners from './modules/vendorPartners';
import createLogger from '../../plugins/logger';

Vue.use(Vuex);

const debug = ['DEV', 'DEBUG'].includes(CONFIG.get('ENV'));

export default new Vuex.Store({
  modules: {
    auth,
    flash,
    main,
    meetingAgendas,
    allergyKpis,
    audiologyKpis,
    banners,
    batteryStore,
    connections,
    digitalPromo,
    fuelFunds,
    fuelUtilization,
    professionalDevelopment,
    library,
    payInvoice,
    pricingGuides,
    purchaseActivity,
    vendorPartners,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});
